import { showSearchBoxesOverlay } from '././searchable_field_utils/search_boxes_overlay';
import { reattachExpandableBoxListener } from '././searchable_field_utils/search_boxes_box';


export function clearSearchBoxes() {
    console.log("clearSearchBoxes called");

    const searchBoxesListContainer = document.getElementById('search-boxes-list');
    if (searchBoxesListContainer) {
        searchBoxesListContainer.innerHTML = ''; // Clear the content
        searchBoxesListContainer.classList.add('d-none'); // Hide the container
    } else {
        console.error("Element with ID 'search-boxes-list' not found.");
    }

    const expandableBox = document.querySelector('.expandable-box');
    if (expandableBox) {
        expandableBox.classList.remove('d-none');
        expandableBox.classList.remove('expandable-box-locked'); // Remove any locked state
    } else {
        console.error("Element with class 'expandable-box' not found.");
    }

    showSearchBoxesOverlay(); // Show the overlay

    // Redirect to the same URL without any parameters
    window.location.href = window.location.pathname;
}


// Function to handle search form submission
export function handleSearchFormSubmission() {
    console.log("handleSearchFormSubmission called");
    clearSearchBoxes(); // Clear the search boxes and show the overlay
}

// Function to redirect with search box parameters
export function redirectSearchBoxes() {
    console.log("redirectSearchBoxes called");
    showSearchBoxesOverlay(); // Show the overlay
    // Get the form element
    const form = document.querySelector('.festi-form-inline-row');

    // Get the form data
    const formData = new FormData(form);

    // Construct the new URL with search parameters
    const baseUrl = form.getAttribute('action');
    const newUrl = `${baseUrl}?${new URLSearchParams(formData).toString()}`;

    // Redirect to the new URL
    window.location.href = newUrl;

    // Add the overlay class to the expandable box until the new URL is fully loaded
    const expandableBox = document.querySelector('.expandable-box');
    expandableBox.classList.add('expandable-box-overlay');

    // Listen for the load event on the window to remove the overlay class
    window.addEventListener('load', function() {
        expandableBox.classList.remove('expandable-box-overlay');
    });
}

// Event listener for the Clear button
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('clear-search-button')) {
        showSearchBoxesOverlay();
        event.preventDefault(); // Prevent the default form submission behavior only when the Clear button is clicked
        clearSearchBoxes(); // Call the clearSearchBoxes function, which calls the overlay
        const form = document.querySelector('.festi-form-inline-row');
        form.reset();
    }
});



// Event listener for the Search button
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('festi-search-button')) {
        event.preventDefault(); // Prevent the default form submission behavior
        handleSearchFormSubmission(); // Handle the search form submission
        redirectSearchBoxes(); // Redirect with search box parameters
    }
});

// Event listener for the Search button
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('festi-search-button')) {
        event.preventDefault(); // Prevent the default form submission behavior
        // Show the overlay
        showSearchBoxesOverlay();
        handleSearchFormSubmission(); // Handle the search form submission
        redirectSearchBoxes(); // Call the redirectSearchBoxes function
        // Disable the expandable box until the page fully reloads
        const expandableBox = document.querySelector('.expandable-box');
        expandableBox.classList.add('expandable-box-disabled');
        console.log("Search button clicked");
    }
});
